(() => {
  const POPUP_HEADING = 'FREE Personalised Football Print';
  const style = document.createElement('style');
  style.textContent = 'body:not(.buryprints-popup-ready) [data-buryprints-delayed-popup]{display:none!important}';
  document.head.appendChild(style);

  const makePopupAccessible = () => {
    const heading = [...document.querySelectorAll('.klaviyo-form h1')].find(
      (element) => element.textContent.trim() === POPUP_HEADING
    );

    if (!heading) return;

    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) {
      replacement.setAttribute(attribute.name, attribute.value);
    }
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);

    let overlay = replacement.closest('.klaviyo-form');
    while (overlay && overlay.parentElement && getComputedStyle(overlay).position !== 'fixed') {
      overlay = overlay.parentElement;
    }
    if (overlay && getComputedStyle(overlay).position === 'fixed') {
      overlay.setAttribute('data-buryprints-delayed-popup', '');
    }
  };

  const observer = new MutationObserver(makePopupAccessible);
  observer.observe(document.documentElement, { childList: true, subtree: true });
  makePopupAccessible();

  let released = false;
  const releasePopup = () => {
    if (released) return;
    released = true;
    document.body.classList.add('buryprints-popup-ready');
    window.removeEventListener('scroll', checkScroll);
    document.removeEventListener('mouseout', checkExit);
  };
  const checkScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= 0.45) releasePopup();
  };
  const checkExit = (event) => {
    if (event.clientY <= 0 && !event.relatedTarget) releasePopup();
  };

  window.addEventListener('scroll', checkScroll, { passive: true });
  document.addEventListener('mouseout', checkExit);
  window.setTimeout(releasePopup, 30000);
})();
